import type {
  ModifiableModel,
  CreatableModel,
  DeletableModel,
} from 'shared/domain/baseModelTypes';
import type { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import type { ProtocolAnswer } from 'shared/domain/protocolAnswer';
import type { Identificable } from 'shared/types/commonView';

export enum InspectionStatus {
  inProgress = 'IN_PROGRESS',
  completed = 'COMPLETED',
}

export interface ComplianceCheckModel {
  readonly comment?: string;
  readonly issues: string[];
  readonly result: ComplianceAnswerOption;
}

export type ProtocolItemModel = {
  complianceCheck: ComplianceCheckModel;
  templateChecklistItem: string;
  comment?: string;
  answers?: ProtocolAnswer[];
} & ModifiableModel &
  Identificable;

export type ProtocolSectionModel = {
  title: string;
  checklistSectionId?: string;
  comment: string;
  order: string;
  parentSectionId: string | null;
} & CreatableModel &
  ModifiableModel &
  Identificable;

export type InspectionModel = {
  isCompleted: boolean;
  readonly contracts: string[];
  readonly controlledParty: string[];
  readonly inspectionDate: string;
  readonly levels: string[];
  readonly protocol: ProtocolItemModel[];
  readonly sections: ProtocolSectionModel[];
  readonly sites: string[];
  readonly template: string;
  readonly workTypes: string[];
  readonly comment?: string;
  relatedIssuesCount?: number;
} & CreatableModel &
  ModifiableModel &
  DeletableModel &
  Identificable;
